<template>
    <b-modal
        id="modalPresetFrames"
        centered
        hide-footer
        ref="modalPresetFrames"
        no-close-on-backdrop
        no-close-on-esc
        header-class="align-items-center"
        modal-class="modal-preset-frames"
        scrollable
    >
        <template v-slot:modal-header>
            <h5 class="m-0">{{ title }}</h5>

            <button class="btn btn-link" @click="handleButtonClose">
                <i class="fal fa-times"></i>
            </button>
        </template>

        <b-tabs 
            class="mb-3"
            nav-class="navs-preset"
            active-nav-item-class="navs-preset--item-active"
        >
            <b-tab
                title-link-class="newSection-listItem"
                title-item-class="navs-preset--item"
                v-for="filter in filters"
                :title="filter.name"
                :key="filter.id"
                @click.prevent="resetSectionActive(filter.type)"
            >
                <div class="row no-gutters" style="gap: 1rem;">
                    <button
                        v-for="section in sectionsFiltered"
                        :key="section.id"
                        :title="section.title"
                        v-b-tooltip.hover
                        @click.prevent="setActive(section.id)"
                        :class="['button-preset col', activeSection.id == section.id && 'active']"
                    >
                        <img 
                            style="
                                max-width: 30rem;
                                height: 160px;
                                object-fit: scale-down;
                            "
                            :src="section.image"
                            alt=""
                        >
                    </button>
                </div>
            </b-tab>
        </b-tabs>

        <div class="position-sticky ps-l-0 ps-r-0 ps-b-2 d-flex justify-content-end">
            <button class="btn btn-primary mr-3" @click="handleButtonPrimary" :disabled="activeSection.id == null">
                {{ textButtonPrimary }}
            </button>

            <button class="btn btn-secondary" @click="handleButtonClose">
                {{ textButtonClose }}
            </button>
        </div>
    </b-modal>
</template>

<script>
import apiMixins from "@/mixins/apiMixins";
import { mapGetters } from "vuex";

export default {
    name: "ModalPresetFrames",
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        filters: {
            type: Array,
            required: true
        },
        textButtonPrimary: {
            type: String,
            requered: true
        },
        textButtonClose: {
            type: String,
            default: 'Cancelar'
        },
    },
    mixins: [apiMixins],
    computed: {
        ...mapGetters("dashboardModule", ["getSections"]),
        sectionsFiltered() {
            if (this.activeFilter === '') {
                return this.sections;
            }
            
            return this.sections.filter(section => section.type.includes(this.activeFilter));
        }
    },
    created() {
        this.sections = this.getSections;
    },
    watch: {
        show(newValue, oldValue) {
            if (newValue) {
                this.$refs.modalPresetFrames.show();

                this.resetSectionActive();
            } else {
                this.$refs.modalPresetFrames.hide();

                this.resetSectionActive();
            }
        },
    },
    data() {
        return {
            activeSection: {
                id: null,
                title: '',
                picture: '',
                component: '',
                frames: []
            },
            activeFilter: '',
            sections: [],
        }
    },
    methods: {
        setActive(sectionSelected) {
            this.activeSection = this.sections.find(section => section.id === sectionSelected);
        },
        resetSectionActive(type = '') {
            this.activeFilter = type;

            this.activeSection = {
                id: null,
                title: '',
                picture: '',
                component: '',
                frames: []
            };
        },
        handleButtonPrimary() {
            this.$emit('handleButtonPrimary', this.activeSection)
        },
        handleButtonClose() {
            this.$emit('handleButtonClose')
        }
    }
}
</script>

<style>
#modalPresetFrames .modal-dialog {
    width: 80vw;
    height: 80vh;
    max-width: 80%;
    max-height: 80%;
}

.modal-preset-frames .button-preset {
    border: 2px solid #ccc;
    border-radius: 5px;
    background-color: #fff;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}

.modal-preset-frames .button-preset.active {
  border: 2px solid var(--main-color);
}

.modal-preset-frames .navs-preset {
    margin-bottom: 1rem !important;
    padding: unset !important;
}

.modal-preset-frames .navs-preset--item {
    position: relative;
    padding: 0.5rem 1rem;
    border: 2px solid transparent;
    border-radius: 5px;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    background-color: #fff;
}

.modal-preset-frames .navs-preset--item:has(.navs-preset--item-active) {
    border: 2px solid var(--main-color);
}

.modal-preset-frames .navs-preset--item-active {
    border: unset;
}

.btn.btn-primary:disabled {
    cursor: not-allowed;
    background: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/ModalPresetFrames.vue